import React from "react";
import { useAudienceList } from "./AudienceList.hooks";

const AudienceListContext = React.createContext<ReturnType<
  typeof useAudienceList
> | null>(null);

export function useAudienceListView() {
  const contextValue = React.useContext(AudienceListContext);
  if (!contextValue) {
    throw Error("Should be used inside the AudienceListProvider");
  }
  return contextValue;
}

export const AudienceListProvider = AudienceListContext.Provider;
